import React from "react";
import My_Appointments from '../../containers/Medical_Request/Index'

export default function Index() {
    return <My_Appointments />;
}
